import { Path, Svg, SvgProps } from 'react-native-svg';

const Trailer = ({ color, ...props }: SvgProps) => (
  <Svg viewBox='0 0 24 24' fill='none' {...props}>
    <Path
      d='M4 17a2 2 0 1 0 4 0 2 2 0 1 0-4 0M14 17a2 2 0 1 0 4 0 2 2 0 1 0-4 0'
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M8 17H5V8.5A1.5 1.5 0 0 1 6.5 7H13v10M13 7h4.2L20 11.2V17h-2'
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path d='M3 10h3' stroke={color} strokeWidth={1.5} strokeLinecap='round' />
  </Svg>
);

export { Trailer };
